export default {
  // Meta Tags (for social media previews)
  metaTitle: '{{petName}}のケア情報',
  metaDescription: '{{petName}}の詳細なケア情報（食事、健康、行動など）をご覧ください',
  
  // Loading & Error States
  loadingPet: 'ペットデータを読み込み中...',
  petInfoNotFound: 'ペット情報が見つかりません',
  linkExpiredOrIncorrect: 'この共有リンクは期限切れまたは正しくありません',
  backToHome: 'ホームに戻る',
  
  // Age & Time
  year: '歳',
  years: '歳',
  month: 'ヶ月',
  months: 'ヶ月',
  unknown: '不明',
  
  // Security
  securityReminder: 'セキュリティリマインダー',
  shareOnlyWithTrusted: 'このデータにはペットの個人データが含まれています。信頼できる介護者とのみ共有してください。'
};